import { BetLineWinIndividualWPController } from "@nolimitcity/slot-game/bin/game/winpresentation/individualwin/BetLineWinIndividualWPController";
import { Timeline } from 'gsap';
import { StateReelSymbol } from '@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol';
import { IBetLineWinData } from '@nolimitcity/slot-game/bin/core/server/data/IServerData';
import { BarbarianFuryGameModuleConfig } from '../../BarbarianFuryGameModuleConfig';
import { EventHandler } from '@nolimitcity/slot-game/bin/core/event/EventHandler';
import { GameEvent } from '@nolimitcity/slot-game/bin/core/event/GameEvent';


export class BarbarianFuryIndividualWPController extends BetLineWinIndividualWPController {

    /**
     * override this function to play fire animation on
     * @param betLineWinData 
     * @param timeline 
     * @param startTime 
     * @param symbol 
     * @param reelId 
     * @param symbolId 
     */
    protected addSymbolWinAnimationToTimeline(betLineWinData: IBetLineWinData, timeline: Timeline, startTime: number, symbol: StateReelSymbol, reelId: number, symbolId: number): void {
        BarbarianFuryGameModuleConfig.foregroundAnimation.playSymbolWinAnimation(reelId, symbolId);
        EventHandler.dispatchEvent(new GameEvent("SHOW_INDIVIDUAL_BETLINE_WIN", true));
        super.addSymbolWinAnimationToTimeline(betLineWinData, timeline, startTime, symbol, reelId, symbolId);
    }

    protected stopWinPresentation(isAborted: boolean): void {
        EventHandler.dispatchEvent(new GameEvent("SHOW_INDIVIDUAL_BETLINE_WIN", false));
        BarbarianFuryGameModuleConfig.foregroundAnimation.hideSymbolAnimation();
        super.stopWinPresentation(isAborted);

    }
}